import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import ClickableDescr from 'components/ClickableDescr'
import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import { REGION_JP } from 'constants/regions'
import { US } from 'constants/countries'
import { ResizeContext } from 'contexts/Resize'
import { LocalizationContext } from 'contexts/Localization'
import { useSwitcher } from 'hooks/saveElementIndex'
import { H1Small as H1 } from 'styles/components/typography'

import {
  IconWrapper,
  FrameMacStraightStyled,
  FrameWrapper,
  Content,
  Cover,
  ImageWrapper,
} from './styles'

const IMAGES =
  process.env.region === REGION_JP
    ? ['protection_150921', 'diversity_150921', 'recommendations_150921']
    : ['protection', 'diversity', 'recommendations']

const BResultsHealth = props => {
  const { data, pathCdn } = props
  const { index, updateIndex } = useSwitcher()
  const { mobile } = React.useContext(ResizeContext)
  const { locale, paths: { shared } } = useContext(LocalizationContext)
  const isUs = locale === US

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={<Cover isTablet={true} />}
    >
      <div className='row'>
        <div className='col-12 order-md-1 col-md-8'>
          <Cover />
          <FrameWrapper className='py-md-4'>
            <div className='position-relative py-4 py-md-0'>
              <H1 as='h2' dangerouslySetInnerHTML={{ __html: data.title }} />
              <FrameMacStraightStyled
                src={`${pathCdn}/${IMAGES[index]}`}
                alt={IMAGES[index]}
              >
                {isUs ? (
                  <ImageWrapper className='shield' src={`${shared}/icons/shield.png`} alt={`shield_img`} />
                ) : (
                  <>
                    <IconWrapper className='charts'>
                      <Icon id='color_charts' />
                    </IconWrapper>

                    <IconWrapper className='profile'>
                      <Icon id='color_profile' />
                    </IconWrapper>
                  </>
                )}
              </FrameMacStraightStyled>
            </div>
          </FrameWrapper>
        </div>
        <div className='col-12 py-4 order-md-0 col-md-4'>
          <Content>
            <ul className='list--unstyled w-100'>
              {data.list.map((item, key) => (
                <ClickableDescr
                  key={key}
                  isActive={index === key}
                  noHover={mobile || data.list.length === 1}
                  onClick={() => updateIndex(key)}
                  arrowPosition='right'
                  bulletColor={'#7645EF'}
                  data={{
                    title: item.title,
                    description: item.content,
                  }}
                />
              ))}
            </ul>
          </Content>
        </div>
      </div>
    </SectionWrapper>
  )
}

BResultsHealth.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default BResultsHealth
